module.exports = __webpack_public_path__ + "img/visitorGuide1.6ef0e9eb.jpg";